/**
 * Sidebar navigation items with Solar Duotone icons from @iconify/react.
 * Each section maps to the admin nav structure with luxury icon choices.
 */

export const sectionItemsWithTeams = [
  {
    key: "content",
    title: "Content",
    items: [
      { key: "dashboard", href: "/admin", icon: "fluent-color:apps-24", title: "Dashboard", exact: true },
      { key: "articles", href: "/admin/articles", icon: "fluent-color:document-text-24", title: "Articles" },
      { key: "calendar", href: "/admin/calendar", icon: "fluent-color:calendar-24", title: "Editorial Calendar" },
      { key: "commissions", href: "/admin/commissions", icon: "fluent-color:document-edit-24", title: "Commissions" },
      { key: "planning", href: "/admin/planning", icon: "fluent-color:clipboard-text-edit-24", title: "News Diary" },
      { key: "series", href: "/admin/series", icon: "fluent-color:board-24", title: "Content Series" },
      { key: "categories", href: "/admin/categories", icon: "fluent-color:document-folder-24", title: "Categories" },
      { key: "vocabulary", href: "/admin/vocabulary", icon: "fluent-color:book-open-24", title: "Vocabulary" },
      { key: "wiki", href: "/admin/wiki", icon: "fluent-color:library-24", title: "Internal Wiki" },
      { key: "media", href: "/admin/media", icon: "fluent-color:image-24", title: "Media Library" },
      { key: "templates", href: "/admin/templates", icon: "fluent-color:code-24", title: "Templates" },
    ],
  },
  {
    key: "video-audio",
    title: "Video & Audio",
    items: [
      { key: "reels", href: "/admin/reels", icon: "fluent-color:video-24", title: "Reels" },
      { key: "live-streams", href: "/admin/live-streams", icon: "fluent-color:camera-24", title: "Live Streams" },
      { key: "podcasts", href: "/admin/podcasts", icon: "fluent-color:mic-24", title: "Podcasts" },
    ],
  },
  {
    key: "engagement",
    title: "Engagement",
    items: [
      { key: "breaking-news", href: "/admin/breaking-news", icon: "fluent-color:alert-urgent-24", title: "Breaking News" },
      { key: "live-blog", href: "/admin/live-blog", icon: "fluent-color:megaphone-loud-24", title: "Live Blog" },
      { key: "polls", href: "/admin/polls", icon: "fluent-color:poll-24", title: "Polls" },
      { key: "comments", href: "/admin/comments", icon: "fluent-color:comment-multiple-24", title: "Comments" },
      { key: "rss-feeds", href: "/admin/rss-feeds", icon: "fluent-color:news-24", title: "RSS Feeds" },
      { key: "auto-publish", href: "/admin/auto-publish", icon: "fluent-color:arrow-sync-24", title: "Auto-Publisher" },
      { key: "engagement", href: "/admin/engagement", icon: "fluent-color:form-24", title: "Quizzes & Surveys" },
      { key: "ugc", href: "/admin/ugc", icon: "fluent-color:person-feedback-24", title: "UGC Submissions" },
    ],
  },
  {
    key: "people",
    title: "People",
    items: [
      { key: "users", href: "/admin/users", icon: "fluent-color:people-24", title: "Users", permission: "manage_users" },
      { key: "hr", href: "/admin/hr", icon: "fluent-color:building-people-24", title: "HR & Staff", permission: "manage_users" },
      { key: "org-chart", href: "/admin/org-chart", icon: "fluent-color:org-24", title: "Org Chart" },
      { key: "freelancers", href: "/admin/freelancers", icon: "fluent-color:person-available-24", title: "Freelancers", permission: "manage_users" },
      { key: "leave", href: "/admin/leave", icon: "fluent-color:beach-24", title: "Leave Management" },
      { key: "shifts", href: "/admin/shifts", icon: "fluent-color:shifts-24", title: "Shift Scheduling", permission: "manage_users" },
      { key: "reviews", href: "/admin/reviews", icon: "fluent-color:ribbon-star-24", title: "Performance", permission: "manage_users" },
      { key: "recruitment", href: "/admin/recruitment", icon: "fluent-color:briefcase-24", title: "Recruitment", permission: "manage_users" },
      { key: "timesheets", href: "/admin/timesheets", icon: "fluent-color:clock-24", title: "Timesheets" },
      { key: "okrs", href: "/admin/okrs", icon: "fluent-color:flag-24", title: "OKRs & Goals" },
      { key: "lms", href: "/admin/lms", icon: "fluent-color:book-open-lightbulb-24", title: "Learning (LMS)" },
      { key: "contracts", href: "/admin/contracts", icon: "fluent-color:document-lock-24", title: "Contracts" },
      { key: "sources", href: "/admin/sources", icon: "fluent-color:book-contacts-24", title: "Source Contacts" },
    ],
  },
  {
    key: "distribution",
    title: "Distribution",
    items: [
      { key: "newsletter", href: "/admin/newsletter", icon: "fluent-color:mail-24", title: "Newsletter" },
      { key: "newsletter-builder", href: "/admin/newsletter-builder", icon: "fluent-color:mail-multiple-24", title: "Newsletter Builder" },
      { key: "social-media", href: "/admin/social-media", icon: "fluent-color:share-android-24", title: "Social Media" },
      { key: "competitors", href: "/admin/competitors", icon: "fluent-color:search-visual-24", title: "Competitor Monitor" },
      { key: "marketing", href: "/admin/marketing", icon: "fluent-color:data-trending-24", title: "Marketing" },
    ],
  },
  {
    key: "system",
    title: "System",
    items: [
      { key: "notifications", href: "/admin/notifications", icon: "fluent-color:alert-24", title: "Notifications" },
      { key: "analytics", href: "/admin/analytics", icon: "fluent-color:chart-multiple-24", title: "Analytics" },
      { key: "analytics-stream", href: "/admin/analytics-stream", icon: "fluent-color:database-24", title: "Data Warehouse" },
      { key: "web-vitals", href: "/admin/web-vitals", icon: "fluent-color:gauge-24", title: "Performance & Vitals" },
      { key: "sustainability", href: "/admin/sustainability", icon: "fluent-color:planet-24", title: "Sustainability & ESG" },
      { key: "finance", href: "/admin/finance", icon: "fluent-color:coin-multiple-24", title: "Finance", permission: "super_admin" },
      { key: "finance-full", href: "/admin/finance-full", icon: "fluent-color:receipt-24", title: "Invoicing & P&L", permission: "super_admin" },
      { key: "payroll", href: "/admin/payroll", icon: "fluent-color:savings-24", title: "Payroll", permission: "super_admin" },
      { key: "ecommerce", href: "/admin/ecommerce", icon: "fluent-color:building-store-24", title: "E-Commerce" },
      { key: "live-data", href: "/admin/live-data", icon: "fluent-color:data-line-24", title: "Live Data Feeds" },
      { key: "field-ops", href: "/admin/field-ops", icon: "fluent-color:location-ripple-24", title: "Field Operations" },
      { key: "seo", href: "/admin/seo", icon: "fluent-color:search-sparkle-24", title: "SEO & Scheduling" },
      { key: "seo-advanced", href: "/admin/seo-advanced", icon: "fluent-color:data-scatter-24", title: "SEO Advanced", permission: "manage_users" },
      { key: "support", href: "/admin/support", icon: "fluent-color:headset-24", title: "Support Center" },
      { key: "equipment", href: "/admin/equipment", icon: "fluent-color:toolbox-24", title: "Equipment", permission: "manage_users" },
      { key: "gdpr", href: "/admin/gdpr", icon: "fluent-color:shield-checkmark-24", title: "GDPR & Privacy", permission: "super_admin" },
      { key: "gdpr-full", href: "/admin/gdpr-full", icon: "fluent-color:globe-shield-24", title: "GDPR Full Suite", permission: "super_admin" },
      { key: "system-dr", href: "/admin/system-dr", icon: "fluent-color:cloud-24", title: "DR & Observability", permission: "super_admin" },
      { key: "audit", href: "/admin/audit", icon: "fluent-color:clipboard-task-24", title: "Audit Logs", permission: "manage_users" },
      { key: "governance", href: "/admin/governance", icon: "fluent-color:building-government-24", title: "Compliance & Governance", permission: "super_admin" },
      { key: "ai-governance", href: "/admin/ai-governance", icon: "fluent-color:bot-sparkle-24", title: "AI Model Audit" },
      { key: "ads", href: "/admin/ads", icon: "fluent-color:slide-text-sparkle-24", title: "Ad Manager", permission: "super_admin" },
      { key: "entitlements", href: "/admin/entitlements", icon: "fluent-color:gift-card-24", title: "Entitlements", permission: "super_admin" },
      { key: "corporate-seats", href: "/admin/corporate-seats", icon: "fluent-color:building-multiple-24", title: "Corporate Seats" },
      { key: "ab-tests", href: "/admin/ab-tests", icon: "fluent-color:molecule-24", title: "Headline A/B Tests" },
      { key: "account-security", href: "/admin/account-security", icon: "fluent-color:lock-shield-24", title: "Account Security" },
      { key: "settings", href: "/admin/settings", icon: "fluent-color:settings-24", title: "Settings", permission: "super_admin" },
    ],
  },
];
